const toRadians = (degrees) => (Number(degrees) * Math.PI) / 180;

const pointDistanceMeters = (a, b) => {
  const radius = 6371000;
  const dLat = toRadians(Number(b?.lat) - Number(a?.lat));
  const dLon = toRadians(Number(b?.lon ?? b?.lng) - Number(a?.lon ?? a?.lng));
  const latA = toRadians(a?.lat);
  const latB = toRadians(b?.lat);
  const value =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(latA) * Math.cos(latB) * Math.sin(dLon / 2) ** 2;
  return 2 * radius * Math.asin(Math.sqrt(value));
};

export function filterPointsByNodes(nodes, points, minMeters) {
  if (!Array.isArray(points) || !points.length) return [];
  if (!Array.isArray(nodes) || !nodes.length) return points;
  const threshold = Math.max(1, Number(minMeters) || 0);
  return points.filter((point, index) => {
    // Primeiro e último pontos são escolhas explícitas e definem as ligações
    // topológicas do trecho. A desduplicação só pode remover pontos interiores.
    if (index === 0 || index === points.length - 1) return true;
    return !nodes.some((node) => pointDistanceMeters(node, point) <= threshold);
  });
}
